import { Input } from 'antd';

const CustomAppInput = ({ Form, rules, data, parentKey, handleTracking }) => {
  return (
    <Form.Item
        name={[parentKey, data.name]}
      label={data.title}
      rules={rules[data.name]}
      className='form_group'
    >
       <Input
          autoComplete={'off'}
          className='form_control'
          name={data.name}
          onBlur={data.onBlurTrack ? handleTracking : () => {}}
          placeholder={data.placeholder}
          maxLength={data.maxLength}
          pattern={data.pattern}
        />
    </Form.Item>
  );
};

export default CustomAppInput;
